import { render } from "./ComponenteOtrosDatos.vue?vue&type=template&id=44e98a76&scoped=true"
import script from "./ComponenteOtrosDatos.vue?vue&type=script&lang=js"
export * from "./ComponenteOtrosDatos.vue?vue&type=script&lang=js"

import "./ComponenteOtrosDatos.vue?vue&type=style&index=0&id=44e98a76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e98a76"]])

export default __exports__